import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconWorldPin } from "@tabler/icons-react";
import { PaisesDef } from "./PaisesDef";

export const PaisesIcon = IconWorldPin;
export const PaisesHelpText = "* Aquí podra ver la lista de paises";

export class Paises extends Entity<PaisesDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PaisesDef(), parentKeys);
        this.Form = import('./PaisesForm').then((module) => module.PaisesForm);
        this.Title = "Paises";
        this.Icon = PaisesIcon;
        this.HelpText = PaisesHelpText;
    }
}